export default __webpack_public_path__ + "static/media/social_email.6601731f.svg";